import { Component, OnInit, Input } from '@angular/core';
import { CampaignService } from 'src/app/_services/campaign.service';
import { ActivatedRoute,  Router } from '@angular/router';

@Component({
  selector: 'app-campaign-header',
  templateUrl: './campaign-header.component.html',
  styleUrls: ['./campaign-header.component.scss']
})
export class CampaignHeaderComponent implements OnInit {

  campaignData: any;
  showAddCandidatePage:any;
  filters:any;
  @Input() event: any;
  @Input() filtersApplied:any;
  campaign_status_id: number;
  currentCampaignId: any;
  campaignStatus:any;
 
  constructor( private emailCampaignService:CampaignService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.currentCampaignId = +this.route.snapshot.paramMap.get('campaign_id')
    this.event.subscribe((res: any)=>{
      this.campaignData = res;
      this.campaignStatus = res.status;
    })
    this.filtersApplied.subscribe((res:any)=>{
      this.showAddCandidatePage = res.addCandidate;
      this.filters= res.filters;
    })
  }
  
  changeStatus(event){
    this.emailCampaignService.updateCampaign( {status: event.target.value, campaign_id: this.currentCampaignId}).subscribe(res=>{
    })
  }
  navigateToStages(){
    this.router.navigate(['email-campaign/create-campaign-stages/' + this.currentCampaignId])
  }
}
